var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00021 15.1668C4.53355 15.1668 1.72021 12.3468 1.72021 8.88676C1.72021 5.42676 4.53355 2.6001 8.00021 2.6001C8.71355 2.6001 9.40688 2.7001 10.0735 2.90676C10.3402 2.98676 10.4869 3.26676 10.4069 3.53343C10.3269 3.8001 10.0469 3.94676 9.78021 3.86676C9.21355 3.69343 8.61355 3.6001 8.00021 3.6001C5.08688 3.6001 2.72021 5.96676 2.72021 8.8801C2.72021 11.7934 5.08688 14.1601 8.00021 14.1601C10.9135 14.1601 13.2802 11.7934 13.2802 8.8801C13.2802 7.82676 12.9735 6.81343 12.3935 5.94676C12.2402 5.7201 12.3002 5.40676 12.5335 5.25343C12.7602 5.1001 13.0735 5.1601 13.2269 5.39343C13.9202 6.42676 14.2869 7.63343 14.2869 8.88676C14.2802 12.3468 11.4669 15.1668 8.00021 15.1668Z",
    fill: "#43494F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7531 4.04664C10.6131 4.04664 10.4731 3.98664 10.3731 3.87331L8.44647 1.65998C8.26647 1.45331 8.28647 1.13331 8.49314 0.95331C8.69981 0.77331 9.01981 0.79331 9.19981 0.999976L11.1265 3.21331C11.3065 3.41998 11.2865 3.73998 11.0798 3.91998C10.9931 4.00664 10.8731 4.04664 10.7531 4.04664Z",
    fill: "#43494F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50648 5.68647C8.35315 5.68647 8.19982 5.61314 8.09982 5.47981C7.93982 5.25981 7.98648 4.94647 8.20648 4.77981L10.4531 3.13981C10.6731 2.97314 10.9865 3.02647 11.1531 3.24647C11.3198 3.46647 11.2665 3.77981 11.0465 3.94647L8.79982 5.59314C8.71315 5.65981 8.61315 5.68647 8.50648 5.68647Z",
    fill: "#43494F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.3bdcceb029a93ed9ef741af4099b9cfb.svg";
export { ForwardRef as ReactComponent };